import React from "react";
import AllOtherServesList from "./AllOtherServesList";

export default function AssignedOtherServesList() {
  return (
    <div>
      <AllOtherServesList api="otherassignenquirylist" />
    </div>
  );
}
